export const SURVEY_TYPE = {
  REGISTRANT_SURVEY: 'RegistrantSurvey',
  DECLINEE_SURVEY: 'DeclineeSurvey',
  CANCELLATION_INFORMATION: 'CancellationInformation',
  SESSION_REGISTRATION_QUESTIONS: 'SessionRegistrationQuestions',
  ADMISSION_ITEM_REGISTRATION_QUESTIONS: 'AdmissionItemRegistrationQuestions',
  HOTEL_QUESTIONS: 'HotelQuestions',
  AIR_QUESTIONS: 'AirQuestions',
  AIR_ACTUAL_QUESTIONS: 'AirActualQuestions',
  CAR_QUESTIONS: 'CarQuestions',
  HOTEL_ALTERNATE_QUESTIONS: 'HotelAlternateQuestions',
  AIR_ALTERNATE_QUESTIONS: 'AirAlternateQuestions',
  AIR_ACTUAL_ALTERNATE_QUESTIONS: 'AirActualAlternateQuestions',
  CAR_ALTERNATE_QUESTIONS: 'CarAlternateQuestions',
  GROUP_FLIGHT_QUESTIONS: 'GroupFlightQuestions',
  GROUP_FLIGHT_ALTERNATE_QUESTIONS: 'GroupFlightAlternateQuestions'
};

export const QUESTION_DISPLAY_TYPE = {
  ALL: 0,
  ANSWERED: 1
};
